import { Component } from '@angular/core';
import { Notification } from 'hx-services';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'hc-alert',
    templateUrl: './hc-alert.component.html',
    styleUrls: ['./hc-alert.component.css'],
    imports: [NgFor, NgIf]
})
export class HcAlertComponent {
  events: Array<Notification> = [];

  constructor() {
  }

  closeAlert(item: Notification, index: number) {
    this.events.splice(index, 1);
  }
}
